
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = (props) => {
    const { footerClass } = props;
    return (
        <>
            <footer id="react-footer" className={footerClass ? footerClass : 'react-footer home-main'}>
                <div className="copyright">  
                    <div className="container">                  
                        <div className="react-copy-left">&copy; 2026 <Link to="/">MindMetric Aptitude</Link> All Rights Reserved</div>
                        <div className="react-copy-right">
                            {/* Social links removed for now */}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;